import styled, { css } from "styled-components";

export const CardContainer = styled.div<{ status: "ongoing" | "onMyWay" }>`
  display: flex;
  gap: 32px;
  justify-content: space-between;
  height: 164px;
  & > div {
    flex: 1;
  }
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  transition: all 0.3s ease;

  h2 {
    font-weight: 400;
  }

  h6 {
    font-weight: 300;
  }

  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  ${(props) =>
    props.status === "ongoing" &&
    css`
      background-color: #2460b8;
      color: #fff;

      .divider-wrapper .MuiDivider-root {
        border-color: #fff;
        border-width: 1px;
      }
    `}
  ${(props) =>
    props.status === "onMyWay" &&
    css`
      background-color: #f9f9f9;
      color: #333;
      /* border: 2px solid #007bff; */
    `}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title-wrapper {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
  }
`;

export const Title = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Badge = styled.span<{ status: "ongoing" | "onMyWay" }>`
  padding: 10px;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 500;
  
  ${(props) =>
    props.status === "ongoing" &&
    css`
      background-color: #fff;
      color: #2460b8;
      cursor: default;
    `}

  ${(props) =>
    props.status === "onMyWay" &&
    css`
      background-color: #2460b8;
      color: #fff;
    `}
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 0.875rem;
`;

export const PetsCount = styled.span`
  font-weight: 600;
`;
